/*
 * Prestige Coffee: cart extras (Palo Alto theme). Loaded from snippets/gwp-auto-add.liquid on every page.
 * Data comes from sections/ph-cart-extras.liquid via the Section Rendering API.
 *
 * 1. Savings line in the cart drawer and cart page, above the subtotal:
 *    "You're saving $X" ("You're saving $X this Black Friday" from 1 November to 6 December), plus a line for each
 *    free gift in the cart. Hidden when there's nothing saved.
 *
 * 2. Bundle & Save accessories reminder, all year round. Same rules as the free gift reminder (assets/gwp-auto-add.js):
 *    when the cart has a coffee machine or grinder with Bundle & Save accessories, and no accessory yet, a pop-up
 *    appears when the customer opens the cart, presses checkout, or lands on the cart page.
 *    - They can tick accessories and add them (20% off, 15% off accessory kits, applied at checkout).
 *    - "No thanks" or the X: not asked again about that machine for the rest of the visit (sessionStorage).
 *    - At checkout the pop-up pauses checkout, then carries on once they've added or declined.
 *    - The free gift pop-up always goes first; this one waits until it has closed.
 * 3. Bialetti accessories reminder: the same pop-up when the cart has a Bialetti moka pot or gift set and no Bialetti
 *    accessory or spare part, while the Bialetti 20% offer runs (30 October to 6 December). Machines are asked about first.
 * Debug: add ?cx_debug=1 to any URL and watch the browser console.
 */
(function () {
  'use strict';
  if (window.__phCartExtras) return;
  window.__phCartExtras = true;

  var ROOT = (window.theme && window.theme.routes && window.theme.routes.root) ||
             (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';
  var SECTION = 'ph-cart-extras';
  var SKIP_KEY = 'ph_acc_skip';
  var DEBUG = /[?&]cx_debug=1/.test(location.search);
  var CART_WRITE_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var CART_OPEN_SEL = '[data-cart-drawer-toggle], a[href="#cart-drawer"], .cart__toggle, [data-cart-toggle], [data-drawer-toggle="cart"], a[href="/cart"], a[href$="/cart"]';
  var CHECKOUT_SEL = '[name="checkout"], button[name="checkout"], a[href*="/checkout"], [data-checkout-button], .cart__checkout';
  var data = null;
  var open = false;

  function log() { if (DEBUG) console.log.apply(console, ['[CX]'].concat([].slice.call(arguments))); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var baseFetch = (window.__phFetch || window.fetch).bind(window);

  function load() {
    return baseFetch(ROOT + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var doc = new DOMParser().parseFromString(d[SECTION], 'text/html');
        data = JSON.parse(doc.querySelector('[data-ph-cart-extras]').textContent);
        log('data', data);
        return data;
      })
      .catch(function (e) { log('load failed', e); return null; });
  }

  /* ---------- 1. Savings line ---------- */

  var css = document.createElement('style');
  css.textContent =
    '.ph-save{margin:0 0 12px;padding:12px 14px;border-radius:8px;background:#eef3ee;color:#1a1a1a;font-size:14px;line-height:1.4}' +
    '.ph-save strong{color:#3f5a42;font-size:15px}' +
    '.ph-save--bf{background:#0b0b0b;color:#fff;border:1px solid #e8c26b}' +
    '.ph-save--bf strong{color:#e8c26b}' +
    '.ph-save__gift{display:block;margin-top:4px;font-size:13px;opacity:.9}' +
    '.ph-acc-pick .gwp-pick__opt{cursor:pointer}' +
    '.ph-acc-pick .gwp-pick__was{font-size:13px;color:#888;text-decoration:line-through}';
  document.head.appendChild(css);

  function savingsHtml() {
    if (!data || !(data.savings > 0)) return '';
    var html = '<strong>You\'re saving ' + esc(data.savingsText) + (data.bf ? ' this Black Friday' : '') + '</strong>';
    (data.gifts || []).forEach(function (g) {
      html += '<span class="ph-save__gift">Includes your free ' + esc(g.title) + (g.value ? ' (valued at ' + esc(g.value) + ')' : '') + '</span>';
    });
    return html;
  }
  function renderSavings() {
    var html = savingsHtml();
    document.querySelectorAll('.cart__foot-inner, .cart__foot').forEach(function (foot) {
      if (foot.closest('template')) return;
      if (foot.classList.contains('cart__foot') && foot.querySelector('.cart__foot-inner')) return;
      var box = foot.querySelector(':scope > .ph-save');
      if (!html) { if (box) box.remove(); return; }
      if (!box) {
        box = document.createElement('div');
        foot.insertBefore(box, foot.firstChild);
      }
      box.className = 'ph-save' + (data.bf ? ' ph-save--bf' : '');
      box.innerHTML = html;
    });
  }
  function refresh() { return load().then(function () { renderSavings(); }); }
  function refreshSoon() { [400, 1200, 2500].forEach(function (t) { setTimeout(renderSavings, t); }); }

  /* ---------- 2. Accessories reminder ---------- */

  function getSkip() { try { return JSON.parse(sessionStorage.getItem(SKIP_KEY) || '[]') || []; } catch (e) { return []; } }
  function setSkip(l) { try { sessionStorage.setItem(SKIP_KEY, JSON.stringify(l)); } catch (e) {} }
  function candidate() {
    if (!data) return null;
    var skip = getSkip();
    function ok(m) { return m.accessories && m.accessories.length && skip.indexOf(String(m.pid)) === -1; }
    var list = (data.hasAcc ? [] : (data.machines || []).filter(ok))
      .concat(data.hasBiaAcc ? [] : (data.pots || []).filter(ok));
    return list[0] || null;
  }
  function gwpBusy() { return !!document.querySelector('.gwp-pick'); }

  function post(path, body) {
    return baseFetch(ROOT + path, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }

  // resume: function to carry on to checkout afterwards (checkout path), or null (cart path)
  function showPicker(m, resume) {
    if (open || !m) return false;
    open = true;
    var bia = m.kind === 'bia';
    var title = bia ? (data.bf ? 'Black Friday bonus: 20% off Bialetti accessories' : '20% off Bialetti accessories')
      : (data.bf ? 'Black Friday bonus: 20% off accessories' : 'Bundle & Save: 20% off accessories');
    var intro = bia
      ? 'Add Bialetti accessories and spare parts with your ' + esc(m.title) + ' and save 20%. The discount is applied automatically at checkout.'
      : 'Add accessories with your ' + esc(m.title) + ' and save 20% (15% on accessory kits). The discount is applied automatically at checkout.';
    var cards = m.accessories.map(function (a) {
      return '<button type="button" class="gwp-pick__opt" data-acc="' + a.id + '" aria-pressed="false">' +
        '<span class="gwp-pick__img">' + (a.image ? '<img src="' + esc(a.image) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="gwp-pick__name">' + esc(a.name) + '</span>' +
        '<span class="gwp-pick__was">' + esc(a.was) + '</span>' +
        '<span class="gwp-pick__value">' + esc(a.now) + ' (' + a.pct + '% off)</span>' +
        '<span class="gwp-pick__tick" aria-hidden="true">&#10003;</span>' +
        '</button>';
    }).join('');
    var el = document.createElement('div');
    el.className = 'gwp-pick ph-acc-pick';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', 'ph-acc-title');
    el.innerHTML =
      '<div class="gwp-pick__panel">' +
        '<button type="button" class="gwp-pick__close" aria-label="Close" data-acc-close>&times;</button>' +
        '<div class="gwp-pick__head"><div style="width:100%">' +
          '<p class="gwp-pick__title" id="ph-acc-title">' + title + '</p>' +
          '<p class="gwp-pick__intro">' + intro + '</p>' +
        '</div></div>' +
        '<div class="gwp-pick__swipe gwp-swipe-wrap" data-gwp-swipe-wrap>' +
          '<div class="gwp-pick__grid gwp-pick__grid--' + Math.min(m.accessories.length, 3) + '" data-gwp-swipe>' + cards + '</div>' +
        '</div>' +
        '<p class="gwp-pick__note">Tick as many as you like.</p>' +
        '<p class="gwp-pick__error" data-acc-error hidden></p>' +
        '<div class="gwp-pick__actions">' +
          '<button type="button" class="gwp-pick__claim" data-acc-add disabled>Add to cart</button>' +
          '<button type="button" class="gwp-pick__no" data-acc-no>No thanks</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);
    document.documentElement.classList.add('gwp-pick-lock');
    var addBtn = el.querySelector('[data-acc-add]');
    var noBtn = el.querySelector('[data-acc-no]');
    var errEl = el.querySelector('[data-acc-error]');

    function close() {
      if (el.parentNode) el.parentNode.removeChild(el);
      document.documentElement.classList.remove('gwp-pick-lock');
      open = false;
    }
    function skipIt() {
      var l = getSkip();
      if (l.indexOf(String(m.pid)) === -1) l.push(String(m.pid));
      setSkip(l);
    }
    function decline() {
      skipIt();
      close();
      if (resume) resume();
    }
    function selected() {
      return [].map.call(el.querySelectorAll('[data-acc].is-selected'), function (b) { return { id: Number(b.getAttribute('data-acc')), quantity: 1 }; });
    }

    el.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-acc]');
      if (opt) {
        var on = !opt.classList.contains('is-selected');
        opt.classList.toggle('is-selected', on);
        opt.setAttribute('aria-pressed', on ? 'true' : 'false');
        addBtn.disabled = !selected().length;
        var n = selected().length;
        addBtn.textContent = n > 1 ? 'Add ' + n + ' to cart' : 'Add to cart';
        errEl.hidden = true;
        return;
      }
      if (e.target.closest('[data-acc-close]') || e.target === el || e.target.closest('[data-acc-no]')) { decline(); return; }
      if (e.target.closest('[data-acc-add]')) {
        var items = selected();
        if (!items.length) return;
        addBtn.disabled = true; noBtn.disabled = true;
        addBtn.textContent = 'Adding…';
        post('cart/add.js', { items: items }).then(function () {
          skipIt();
          close();
          if (resume) { resume(); return; }
          // Palo Alto doesn't redraw its drawer for changes it didn't make, so reload and reopen the cart
          try { sessionStorage.setItem('gwp_open_cart', '1'); } catch (e2) {}
          location.reload();
        }).catch(function () {
          errEl.textContent = 'Sorry, those accessories couldn\'t be added. Please try again.';
          errEl.hidden = false;
          addBtn.disabled = false; noBtn.disabled = false;
          addBtn.textContent = 'Add to cart';
        });
      }
    });
    el.addEventListener('keydown', function (e) { if (e.key === 'Escape') decline(); });
    return true;
  }

  // After the cart opens: wait for the free gift pop-up (if any) to finish first
  function remindAfterOpen() {
    var tries = 0;
    function attempt() {
      if (gwpBusy()) { if (++tries < 40) setTimeout(attempt, 500); return; }
      refresh().then(function () {
        if (!gwpBusy()) showPicker(candidate(), null);
      });
    }
    setTimeout(attempt, 900);
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('.gwp-pick')) return;
    var co = e.target.closest(CHECKOUT_SEL);
    if (co) {
      if (co.hasAttribute('data-acc-pass') || e.defaultPrevented || gwpBusy() || open) return;
      var m = candidate();
      if (!m) return;
      e.preventDefault();
      e.stopPropagation();
      showPicker(m, function () {
        co.setAttribute('data-acc-pass', '');
        co.click();
        setTimeout(function () { co.removeAttribute('data-acc-pass'); }, 1000);
      });
      return;
    }
    var opener = e.target.closest(CART_OPEN_SEL);
    if (opener && !opener.closest('#cart-drawer')) { refreshSoon(); remindAfterOpen(); }
  }, true);

  // Keep the data and savings line up to date when the cart changes
  var wrapped = window.fetch;
  window.fetch = function (input, init) {
    var url = '';
    try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
    var p = wrapped.apply(window, arguments);
    if (CART_WRITE_RE.test(url)) p.then(function () { setTimeout(function () { refresh().then(refreshSoon); }, 300); }).catch(function () {});
    return p;
  };

  // Page load: data, savings line, and on the cart page the reminder straight away
  var onCartPage = /\/cart\/?$/.test(location.pathname);
  function start() {
    var tag = document.querySelector('script[data-cart-count]');
    if (tag && tag.getAttribute('data-cart-count') === '0') return; // empty cart: nothing to do until something is added
    refresh().then(function () {
      refreshSoon();
      if (onCartPage) remindAfterOpen();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
